module.exports = __webpack_public_path__ + "static/media/privacypolicy.90566494.htm";